import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manager-case-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {
  showNotes = false;

  constructor() { }

  ngOnInit(): void {
  }

}
